import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { TClipLogo, TPatchClipLogo } from '../types';

export async function patchClipLogo(body: TPatchClipLogo): Promise<TClipLogo> {
  return mediaManagerClient.patch(`/api/v1/clip_logos/${body.id}`, emptyStringValues(body));
}

type MutationFn = typeof patchClipLogo;

type TUsePatchClipLogoParams = {
  config?: MutationConfig<MutationFn>;
  invalidateClipQueries?: boolean;
  silently?: boolean;
};

export function usePatchClipLogo({ config = {} }: TUsePatchClipLogoParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: ({ silently = false, ...body }: TPatchClipLogo) =>
      patchClipLogo({ ...body, silently }),
    onError(error) {
      addErrorNotification(t('No se ha podido actualizar el logo del corte'));
      console.error(error);
    },
    onSuccess(_data, variables: TPatchClipLogo) {
      if (!variables.silently) {
        addSuccessNotification(t('El logo del corte se ha actualizado correctamente'));
      }
    },
  });
}
